module.exports = __webpack_public_path__ + "static/media/team_7.3352d8e2.jpg";